import React, { useContext, useEffect, useState } from "react";
import { ITestSlideInContent } from "../../pages/components/TestSlideIn/contentTypes";
export type TestSlideInContent = {
    open: boolean;
    disableClose: boolean;
    toggleDrawer: () => void,
    disableClosingDrawer: (value: boolean) => void,
    content?: ITestSlideInContent,
    slideInProps?: any,
    handleContent: (content: ITestSlideInContent) => void
};

const TestSlideInContext = React.createContext<TestSlideInContent>({
    open: false,
    disableClose: false,
    toggleDrawer: () => { return },
    disableClosingDrawer: (value: boolean) => { return },
    content: undefined,
    slideInProps: undefined,
    handleContent: () => { return }
});

TestSlideInContext.displayName = 'TestSlideInContext';

const useTestSlideInContext = () => useContext(TestSlideInContext);

interface IProps {
    children: React.ReactNode
};

interface IProps {
    children: React.ReactNode
};

const TestSlideInContextProvider = (props: IProps) => {
    const { children } = props;
    const [content, setContent] = useState<ITestSlideInContent>();
    const [open, setOpen] = useState(false);
    const [slideInProps, setSlideInProps] = useState();
    const [disableClose, setDisableClose] = useState(false);

    const handleContent = (_content: ITestSlideInContent, props?: any) => {
        setContent(_content)
        setOpen(true)
        setSlideInProps(props)
        return;
    };

    useEffect(() => {
        if (!open && content) {
            setOpen(true);
        };
    }, [content]);

    const toggleDrawer = () => {
        setOpen(!open)
        return;
    };

    const disableClosingDrawer = (value: boolean) => {
        setDisableClose(value);
        return;
    }

    return (
        <TestSlideInContext.Provider
            value={{
                open,
                disableClose,
                toggleDrawer,
                disableClosingDrawer,
                handleContent,
                content,
                slideInProps
            }}>
            {children}
        </TestSlideInContext.Provider>
    );
};

export { useTestSlideInContext, TestSlideInContextProvider };
